import { emptyStateIcon } from "../icons.js";
import { escapeAttr, escapeHtml } from "../utils/html.js";
import { t } from "../../../../shared/i18n/index.js";

export function renderEmpty(text) {
  return `<div class="mobile-empty">${escapeHtml(text)}</div>`;
}

export function renderViewEmptyState(title, text, actionLabel = "", action = "") {
  return `
    <section class="mobile-view mobile-view-padded">
      ${renderEmptyState(title, text, actionLabel, action)}
    </section>
  `;
}

export function renderEmptyState(title, text, actionLabel = "", action = "") {
  return `
    <div class="mobile-empty-state compact">
      <div class="mobile-empty-icon">${emptyStateIcon()}</div>
      <div class="mobile-empty-title">${escapeHtml(title)}</div>
      <div class="mobile-empty-text">${escapeHtml(text)}</div>
      ${action ? `<button class="mobile-primary-btn compact" data-mobile-action="${escapeAttr(action)}">${escapeHtml(actionLabel || t("common.continue"))}</button>` : ""}
    </div>
  `;
}
